module.exports = __webpack_public_path__ + "static/media/bluejays-ringer-dt-fr.2dec01d4.jpg";